import SimplePage from "./SimplePages";

export default function RefundPolicyPage() {
  return (
    <div data-testid="refund-page">
      <SimplePage title="Refund Policy">
        <p>EQtech Academy is committed to fair enrollment terms. This policy outlines when refunds are available.</p>
        <p><strong>Cooling-off period:</strong> A full refund can be requested within 7 days of enrollment, provided no more than 2 live class sessions have been attended.</p>
        <p><strong>Partial refunds:</strong> After the cooling-off period, refunds are prorated based on classes attended and content accessed. Administrative fees may apply.</p>
        <p><strong>Non-refundable items:</strong> Certification fees, downloaded resources and any 1-on-1 mentorship credits are non-refundable once used.</p>
        <p><strong>Process:</strong> Email refund requests to info@eqtech.academy with your enrollment reference. Refunds are processed within 7-14 business days to the original payment method.</p>
        <p>For questions, reach us via the contact page.</p>
      </SimplePage>
    </div>
  );
}
